// текст ошибки для пользователя из ответа API
// приоритет у context.showError — бэкенд кладет туда сообщение,
// подготовленное для показа, message остается техническим

type TApiErrorData = {
  message?: string
  context?: {
    showError?: string
  }
}

export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const { data } = (error ?? {}) as { data?: TApiErrorData }

  return data?.context?.showError || data?.message || fallback
}
